import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const fetchCurrencies = async () => {
  const { data } = await axios.get('https://api.pixelore.wiki/api/currencies');
  return data;
};

export function useCurrencies() {
  return useQuery({
    queryKey: ['currencies'],
    queryFn: fetchCurrencies,
    staleTime: 1000 * 60 * 30, 
    refetchOnWindowFocus: false,
  });
}
